module.exports = __webpack_public_path__ + "static/media/maxigo-difficulty-blue.e208d79a.png";